module.exports = __webpack_public_path__ + "images/1-ru.jpg?v=5acbaef8f09d4cb26396e9c25c7db181";